import { useAfterPaint } from "hooks/use-after-paint";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectResidency } from "store/quote/selectors";
import { trackPageView } from "utils/tracking";
import {
  mixpanelTrack,
  registerState,
  updateMixpanelUser,
} from "utils/tracking/mixpanel";
import { isOnboardingCtaInView } from "utils/tracking/utils";

export function trackSubmit(state: string) {
  updateMixpanelUser({ state });
  registerState(state);
  mixpanelTrack("setting_residence_state", { residence_state: state });
}

export function useTracking({
  ctaEnabled,
  formName,
}: {
  ctaEnabled: boolean;
  formName?: string;
}) {
  const { pathname } = useLocation();
  const residency = useSelector(selectResidency);
  const afterPaint = useAfterPaint();

  useEffect(() => {
    if (afterPaint) {
      trackPageView("State", pathname, {
        residence_filled: Boolean(residency?.areaLevel1),
        cta_enabled: ctaEnabled,
        cta_in_viewport: isOnboardingCtaInView(formName),
      });
    }
  }, [pathname, afterPaint]);
}
